import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import { Button, ButtonIcon } from "../../styled-components/";
import { makeGetConfigValue } from "../../selectors/config";
import { generateShortcutText } from "../../util/keyShortcutUtils";
import localize from "../../util/localizeUtils";
import Settings from "../../settings";

const Mousetrap = window.Mousetrap;

const FooterContainer = styled.div`
  flex: 0 0 auto;
  padding-left: 0.5rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  z-index: 1;
  width: 100%;
  height: 100%;

  &:first-of-type {
    padding-left: 5rem;
  }

  > button:first-of-type {
    margin-right: 1rem;
  }
`;

class BrowseContentFooter extends Component {
  constructor() {
    super();

    this.clipper = null;
  }

  componentDidMount = () => {
    this.bindShortcuts();
  };

  componentWillUnmount = () => {
    console.log("browse content footer unmount will");
    this.unbindShortcuts();
  };

  getComposeButtonLabel() {
    return generateShortcutText(
      localize("composeButton"),
      this.props.isModifierActive
    );
  }

  getOrderButtonLabel() {
    return generateShortcutText(
      this.props.assetType === "image"
        ? localize("orderImageButton")
        : localize("orderMovieButton"),
      this.props.isModifierActive
    );
  }

  bindShortcuts = () => {
    const { openCompose, openOrder } = this.props.shortcuts;
    const { openBuildGraphicDialog, openOrderGraphicDialog } = this.props;
    Mousetrap.bindGlobal(openCompose, () => {
      const { assetType, showComposeImages, showComposeMovies } = this.props;
      if (assetType === "image" && showComposeImages) {
        openBuildGraphicDialog();
      } else if (
        assetType === "video" &&
        showComposeMovies &&
        Settings.enableClipper
      ) {
        // open clipper
      }
    });
    Mousetrap.bindGlobal(openOrder, () => {
      if (this.props.showOrderButton) {
        openOrderGraphicDialog();
      }
    });
  };

  unbindShortcuts = () => {
    const { openCompose, openOrder } = this.props.shortcuts;
    Mousetrap.bindGlobal(openCompose);
    Mousetrap.bindGlobal(openOrder);
  };

  renderComposeButton() {
    const {
      openBuildGraphicDialog,
      showComposeImages,
      showComposeMovies,
      assetType
    } = this.props;
    if (
      (assetType === "image" && showComposeImages) ||
      (assetType === "video" && showComposeMovies && Settings.enableClipper)
    ) {
      return (
        <Button onClick={openBuildGraphicDialog}>
          <FontAwesomeIcon fixedWidth size="lg" icon={faPencilAlt} />
          {this.getComposeButtonLabel()}
        </Button>
      );
    }
  }
  renderOrderButton() {
    if (this.props.showOrderButton) {
      return (
        <Button onClick={this.props.openOrderGraphicDialog}>
          <ButtonIcon src="images/orderIndicator.png" />
          &nbsp;{this.getOrderButtonLabel()}
        </Button>
      );
    }
  }
  render() {
    return (
      <FooterContainer>
        {this.renderComposeButton()}
        {/* this.renderOrderButton()*/}
      </FooterContainer>
    );
  }
}

BrowseContentFooter.defaultProps = {
  openOrderGraphicDialog: () => {},
  openBuildGraphicDialog: () => {},
  buildGraphicButtonVisible: false,
  assetType: "",
  showOrderButton: false,
  showComposeMovies: true,
  showComposeImages: true
};

BrowseContentFooter.propTypes = {
  openOrderGraphicDialog: PropTypes.func,
  openBuildGraphicDialog: PropTypes.func,
  assetType: PropTypes.string,
  showOrderButton: PropTypes.bool,
  showComposeImages: PropTypes.bool,
  showComposeMovies: PropTypes.bool,
  shortcuts: PropTypes.shape({
    openCompose: PropTypes.arrayOf(PropTypes.string),
    openOrder: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  isModifierActive: PropTypes.bool.isRequired
};

const makeMapStateToProps = () => {
  const getConfigValue = makeGetConfigValue();

  const mapStateToProps = state => {
    const { canCreateOrders } = state.auth.axisUserProfile;

    return {
      assetType: state.content.assetType.toLowerCase(),
      showOrderButton:
        canCreateOrders &&
        getConfigValue(state, "userConfig", "orderDisplay", "show") === "show",
      showComposeImages:
        getConfigValue(state, "userConfig", "composeImagesDisplay", "show") ===
        "show",
      showComposeMovies:
        getConfigValue(state, "userConfig", "composeMoviesDisplay", "show") ===
        "show",
      shortcuts: state.keyShortcuts.shortcuts,
      isModifierActive: state.keyShortcuts.isModifierActive
    };
  };

  return mapStateToProps;
};

export default connect(makeMapStateToProps)(BrowseContentFooter);



// WEBPACK FOOTER //
// ./app/components/ContentSelection/BrowseContentFooter.js